function getRandomId() {
    return (Math.random() + 0.00001).toString(36).substr(2, 5)
        + (Math.random() + 0.0000001).toString(36).substr(2, 5);
}

export {
    getRandomId
}